


































import Vue, { PropType } from 'vue';
import { AppointmentType, ApptLocation, DesignCenterLocationElement, Member, ScheduleApptDetails } from '@/types';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'TeamMembers',
  data () {
    return {
      selectedTeamMember: {} as Member,
      isAnySelected: false,
      selectedLocation: '',
      multipleLocationsAvailable: false,
      EventType
    }
  },
  props: {
    teamMembers: {
      type: Array as PropType<Member[]>,
      required: true
    },
    appointmentType: {
      type: Object as PropType<AppointmentType>,
      required: true
    },
    appointmentDetails: {
      type: Object as PropType<ScheduleApptDetails>,
      required: true
    },
    appointmentLocations: {
      type: Object as PropType<DesignCenterLocationElement>,
      required: true
    }
  },
  computed: {
    isSelectedTeammember (): boolean {
      return (!!this.selectedTeamMember?.userId || this.isAnySelected) && !!this.selectedLocation;
    },
    memberAssigned (): boolean {
      return this.appointmentType.isAssignedMemberOfStage;
    }
  },
  mounted () {
    if (this.appointmentDetails.teamMember.length) {
      this.selectedTeamMember = this.appointmentDetails.teamMember[0];
    } else if (this.memberAssigned) {
      this.selectedTeamMember = this.teamMembers[0];
    }
    this.setSelectedLocation();
  },
  methods: {
    setTeamMember () {
      if (this.selectedTeamMember.userId) {
        this.$emit(EventType.SET_TEAM_MEMBER, {
          teamMember: this.selectedTeamMember,
          location: this.selectedLocation
        });
      } else if (this.isAnySelected) {
        this.$emit(EventType.SELECT_ANY_TEAM_MEMBER, {
          teamMember: this.teamMembers,
          location: this.selectedLocation
        });
      }
    },
    onTeamMemberSelected (member: Member) {
      this.isAnySelected = false;
      this.selectedTeamMember = this.selectedTeamMember.userId !== member.userId ? member : {} as Member;
    },
    selectAny () {
      this.selectedTeamMember = {} as Member;
      this.isAnySelected = !this.isAnySelected;
    },
    getLocationAddress (location: ApptLocation) {
      return `${location.headline}, ${location.street}, ${location.city}, ${location.state} ${location.zip}`;
    },
    setSelectedLocation () {
      if (this.appointmentLocations.locations.length === 1) {
        this.selectedLocation = this.getLocationAddress(this.appointmentLocations.locations[0]);
        this.$emit(EventType.SET_APPOINTMENT_LOCATION, this.selectedLocation);
      } else {
        this.multipleLocationsAvailable = true;
      }
      if (this.appointmentDetails.location) {
        this.selectedLocation = this.appointmentDetails.location;
      }
    }
  }
});
